<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{$t('addEditTourneeModele.associesFaceReseau.title')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns level is-multiline is-vcentered">
        <div class="column is-narrow level-left ">
          <selecteur-action
            class=""
            @handleAction="handleAction"
            :options='actions'
            :placeholder='$t("general.placeHolder.groupedAction")'
            :titleButton="'general.button.apply'"
            :elementsSelectionnes="getAllTourneeLignesSelected().length > 0 && !isDraggable">
          </selecteur-action>
        </div>
        <div class="level-right columns">
          <div class="column is-4">
            <b-field horizontal
              :label="$t('addEditTourneeModele.associesFaceReseau.dateReference')">
              <b-datepicker
                  :disabled="isDraggable"
                  show-week-number
                  icon="calendar-today"
                  :editable="true"
                  position="is-bottom-left"
                  v-model="dateReference"
                  :nearby-selectable-month-days="true">
              </b-datepicker>
            </b-field>
          </div>
          <div class="column is-8">
            <b-autocomplete
              :disabled="isDraggable"
              icon="magnify"
              v-model="searchAutocomplete"
              :data="dataFacesReseaux"
              @input="getAllFacesAndReseaux"
              field="libelle"
              @select="face => selectForAdd(face)"
              :placeholder="$t('addEditTourneeModele.associesFaceReseau.placeholderAutocomplete')"
              :loading="isFetching" >
              <template slot="empty">
                <div v-if="!isFetching">
                  {{$t('addEditTourneeModele.autocomplete.noRslt')}}
                </div>
                <div v-else>{{$t('addEditTourneeModele.autocomplete.search')}}</div>
              </template>
              <template slot-scope="props">
                <div class="dropdown-item is-paddingless" v-if="props.option.id"
                     :class="{ 'is-disabled is-italic' : props.option.disabled }">
                  {{ props.option.libelle }}
                </div>
                <div v-else class="dropdown-item is-paddingless
              is-disabled has-text-default has-text-weight-bold is-underline">
                  <b>{{$t(props.option.title)}}</b>
                </div>
              </template>
            </b-autocomplete>
          </div>
          <div class="column is-narrow">
            <div class="button is-primary" :class="isDraggable ? 'disabled' : ''"
                 @click="ajoutFace()">
              {{ $t('addEditTourneeModele.associesFaceReseau.addFace') }}
            </div>
          </div>
        </div>
      </div>
      <qd-switch
        class="has-text-default mb-4"
        v-model="isDraggable"
        @input="triLignes">
        {{ $t(('addEditTourneeModele.associesFaceReseau.isDraggable') )}}
      </qd-switch>
      <v-client-table
          v-if="!isDraggable"
          :data="tourneeModele.tourneeLignes"
          class='vueTableFilterStyleFaceAssocies stickyOnlyOnFirstTr'
          :columns="columns"
          :options="options"
          ref='tableFaceAssocies'>
        <div slot="selected" slot-scope="props" class="has-text-centered">
          <b-checkbox v-model="props.row.selected"
                      @input="updateSelected(props.row.faceId, props.row.selected)"
                      :value="props.row">
          </b-checkbox>
        </div>
        <template slot="ordre" slot-scope="props">
            <b-input v-model="props.row.ordre"
                     @input="changeOrdre(props.row.faceId, props.row.ordre)" />
        </template>
        <div slot="delete" slot-scope="props" class="has-text-centered">
          <a @click="deleteLigne(props.row.faceId)">
            <b-icon
              icon="delete-forever"
              type="is-danger">
            </b-icon>
          </a>
        </div>
      </v-client-table>
      <faces-tournee-associes-draggable v-else :tourneeModele="tourneeModele"/>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import {
  SORT_ICON, TEXTS, NO_PER_PAGE_VALUE, NO_PAGINATION,
} from '@/configuration/clientTableConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import getAllElementForAddTournne from '@/services/logistique/tourneeModele/addEditTourneeModele/getAllFacesAndReseaux';
import * as tourneeConf from '@/configuration/logistique/tournee/tourneeConf';
import { getTourneeLigneFromFacePatri }
  from '@/services/logistique/tourneeModele/addEditTourneeModele/getTourneeLigneFromFacePatri';
import getTourneeLigneFromProduitReseau
  from '@/services/logistique/tourneeModele/addEditTourneeModele/getTourneeLigneFromProduitReseau';
import { getTourneeLigneFromPatrimoine }
  from '@/services/logistique/tourneeModele/addEditTourneeModele/getTourneeLigneFromPatrimoine';
import { ACTION_DELETE } from '@/configuration/general/actionsConf';
import selecteurAction from '@/components/general/selecteurAction';
import { SET_TOURNEE_MODELE, SET_MESSAGE_INFO } from '@/store/modules/logistique/tourneeModele-mutation-type';
import { ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import facesTourneeAssociesDraggable from '@/components/logistique/tourneeModele/addEdit/facesTourneeAssociesDraggable';

const Parametres = createNamespacedHelpers('parametres');
const societe = createNamespacedHelpers('societe');
const TourneeModele = createNamespacedHelpers('tourneeModele');

export default {
  props: {
    tourneeModele: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dataFacesReseaux: [],
      dateReference: new Date(),
      isDraggable: false,
      isFetching: false,
      searchAutocomplete: null,
      actions: [
        { action: ACTION_DELETE, translation: 'addEditTourneeModele.actions.delete' },
      ],
      messageInfo: [],
    };
  },
  components: {
    selecteurAction,
    facesTourneeAssociesDraggable,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    materiel() {
      const typeMaterielPresent = this.tourneeModele.tourneeLignes.map(t => t.materiel);
      return (this.parametre(PARAMETRES_KEYS.materielType))
        .filter(materiel => typeMaterielPresent.includes(materiel.id))
        .map((materiel) => ({
          id: materiel.id,
          text: materiel.libelle,
        }));
    },
    format() {
      return (this.parametre(PARAMETRES_KEYS.materielFormat)).map((format) => ({
        id: format.id,
        text: format.libelle,
      }));
    },
    dispositif() {
      const typeDispositifPresent = this.tourneeModele.tourneeLignes.map(t => t.dispositif);
      return (this.parametre(PARAMETRES_KEYS.dispositifType))
        .filter(dispo => typeDispositifPresent.includes(dispo.id))
        .map((dispositif) => ({
          id: dispositif.id,
          text: dispositif.libelle,
        }));
    },
    etat() {
      return ETAT_DISPOSITIF_PUBLICITAIRE.map((etat) => ({
        id: etat.value,
        text: this.$i18n.t(etat.libelle),
      }));
    },
    columns() {
      return [
        'selected',
        'ordre',
        'dispositif',
        'materiel',
        'disposition',
        'face',
        'etat',
        'format',
        'adresse',
        'cp',
        'ville',
        'reseau',
        'commercialisable',
        'delete',
      ];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        headings: {
          ordre: this.$i18n.t('addEditTourneeModele.associesFaceReseau.table.ordre'),
          dispositif: this.$i18n.t('addEditTourneeModele.associesFaceReseau.table.dispositif'),
          materiel: this.$i18n.t('addEditTourneeModele.associesFaceReseau.table.materiel'),
          code: this.$i18n.t('addEditTourneeModele.associesFaceReseau.table.face'),
          etat: this.$i18n.t('addEditTourneeModele.associesFaceReseau.table.etat'),
          format: this.$i18n.t('addEditTourneeModele.associesFaceReseau.table.format'),
          adresse: this.$i18n.t('addEditTourneeModele.associesFaceReseau.table.adresse'),
          cp: this.$i18n.t('addEditTourneeModele.associesFaceReseau.table.CP'),
          ville: this.$i18n.t('addEditTourneeModele.associesFaceReseau.table.ville'),
          reseau: this.$i18n.t('addEditTourneeModele.associesFaceReseau.table.reseau'),
          commercialisable: this.$i18n.t('addEditTourneeModele.associesFaceReseau.table.commercialisable'),
          disposition: this.$i18n.t('addEditTourneeModele.associesFaceReseau.table.disposition'),
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: ['ordre', 'face', 'adresse', 'cp', 'ville', 'reseau', 'dispositif', 'etat', 'format', 'materiel', 'disposition', 'commercialisable'],
        filterByColumn: true,
        listColumns: {
          dispositif: this.dispositif,
          format: this.format,
          materiel: this.materiel,
          etat: this.etat,
          commercialisable: [
            { id: true, text: this.$i18n.t('general.oui') },
            { id: false, text: this.$i18n.t('general.non') },
          ],
        },
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: NO_PAGINATION,
        texts: texts,
        sortIcon: SORT_ICON,
        sortable: ['ordre', 'dispositif', 'materiel', 'disposition', 'face', 'etat', 'format', 'adresse', 'cp', 'ville', 'reseau', 'commercialisable'],
      };
    },
    iconSelectTotal() {
      if (this.allTourneeLignesSelected && this.getAllTourneeLignesSelected().length > 0) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    allTourneeLignesSelected() {
      return this.getAllTourneeLignesSelected().length === this.getTourneesLignesFiltered().length;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    ...TourneeModele.mapMutations({
      setTournee: SET_TOURNEE_MODELE,
      setMessageInfo: SET_MESSAGE_INFO,
    }),
    getTourneesLignesFiltered() {
      let retour = this.tourneeModele.tourneeLignes;
      if (this.$refs.tableFaceAssocies && this.$refs.tableFaceAssocies.filteredData.length > 0) {
        retour = this.tourneeModele.tourneeLignes.filter(tLigne => {
          return this.$refs.tableFaceAssocies.filteredData.map(ligneFiltree => {
            return ligneFiltree.id;
          }).includes(tLigne.id);
        });
      }
      return retour;
    },
    triLignes() {
      const sortedLignes = cloneDeep(this.tourneeModele.tourneeLignes);
      sortedLignes.sort((a, b) => a.ordre - b.ordre);
      this.tourneeModele.tourneeLignes = sortedLignes;
    },
    changeOrdre(faceId, ordre) {
      const tLignes = this.tourneeModele.tourneeLignes.filter((tourneeLigne) => {
        return tourneeLigne.faceId === faceId;
      });
      if (tLignes && tLignes.length > 0) tLignes[0].ordre = ordre;
    },
    async ajoutFace() {
      this.setTournee(this.tourneeModele);
      await this.$router.push({ name: 'l.logistique.tournee_modele-ajoutFace' });
    },
    getAllFacesAndReseaux: debounce(async function getFaces() {
      try {
        this.dataFacesReseaux = [];
        if (!this.searchAutocomplete) return;
        this.isFetching = true;
        const query = {
          societeId: this.societeActiveId,
          auto: this.searchAutocomplete,
          nonCommercialisable: false,
          contientNumerique: false,
          actif: true,
        };
        this.dataFacesReseaux = await getAllElementForAddTournne(
          query, this.tourneeModele.tourneeLignes, this.$route.params.id,
        );
        this.isFetching = false;
      } catch (e) {
        this.isFetching = false;
        messageErreur(this.$i18n);
        throw e;
      }
    }, 500),
    updateSelected(faceId, selected) {
      const tLignes = this.tourneeModele.tourneeLignes.filter((tourneeLigne) => {
        return tourneeLigne.faceId === faceId;
      });
      if (tLignes && tLignes.length > 0) tLignes[0].selected = selected;
    },
    deleteLignesSelected() {
      this.getAllTourneeLignesSelected().forEach((tourneeLigne) => {
        this.deleteLigne(tourneeLigne.faceId);
      });
    },
    deleteLigne(faceId) {
      const index = this.tourneeModele.tourneeLignes.findIndex((tourneeLigne) => {
        return tourneeLigne.faceId === faceId;
      });
      if (index > -1) this.tourneeModele.tourneeLignes.splice(index, 1);
    },
    async selectForAdd(elementsAAjouter) {
      if (!elementsAAjouter || !elementsAAjouter.id || elementsAAjouter.disabled) return;
      let ordre = 10;
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.tourneeModele.tourneeLignes.forEach((tourneeLigne) => {
          if (Number(tourneeLigne.ordre) >= ordre) ordre = Number(tourneeLigne.ordre) + 10;
        });
        const facesIdDejaPresente = this.tourneeModele.tourneeLignes.map((tourneeligne) => {
          return tourneeligne.faceId;
        });
        this.setMessageInfo(this.messageInfo);
        switch (elementsAAjouter.typeProduit) {
          case tourneeConf.TYPE_FACE:
            this.tourneeModele.tourneeLignes = this.tourneeModele.tourneeLignes.concat([
              await getTourneeLigneFromFacePatri(elementsAAjouter, ordre, this.$i18n),
            ]);
            break;
          case tourneeConf.TYPE_REGROUPEMENT_TEMPO:
          case tourneeConf.TYPE_REGROUPEMENT_LC:
            this.tourneeModele.tourneeLignes = this.tourneeModele.tourneeLignes.concat(
              await getTourneeLigneFromProduitReseau(
                elementsAAjouter, ordre, this.societeActiveId, facesIdDejaPresente, this.$i18n,
                this.$route.params.id, this.dateReference, this.messageInfo,
              ),
            );
            this.setMessageInfo(this.messageInfo);
            break;
          case tourneeConf.TYPE_MATERIEL:
          case tourneeConf.TYPE_DISPOSITIF:
          case tourneeConf.TYPE_EMPLACEMENT:
            this.tourneeModele.tourneeLignes = this.tourneeModele.tourneeLignes.concat(
              await getTourneeLigneFromPatrimoine(
                elementsAAjouter, ordre, this.societeActiveId, facesIdDejaPresente, this.$i18n,
                this.$route.params.id, this.messageInfo,
              ),
            );
            this.setMessageInfo(this.messageInfo);
            break;
          default: break;
        }
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    selectAll() {
      const select = !this.allTourneeLignesSelected;
      this.getTourneesLignesFiltered().forEach((el) => {
        el.selected = select;
      });
    },
    getAllTourneeLignesSelected() {
      return this.getTourneesLignesFiltered().filter((el) => {
        return el.selected;
      });
    },
    handleAction(action) {
      switch (action) {
        case ACTION_DELETE:
          this.deleteLignesSelected();
          break;
        default:
          messageErreur(this.$i18n, this.$i18n.t('addEditTourneeModele.errors.noActionSelect'));
          break;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.materielType,
        PARAMETRES_KEYS.materielFormat,
        PARAMETRES_KEYS.dispositifType,
      ]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
